<div class="top-bar">
  <button type="button" class="btn btn-save btn-lg" (click)="updateTemplate()"> 儲 存
  </button>
</div>
